module.exports = __webpack_public_path__ + "img/thumb-dadels-met-bacon-en-amandelen.4b55ef72.jpeg";